export function hexToRGBA(hex: string, alpha: number) {
  hex = hex.replace(/^#/, '');

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const validAlpha = Math.min(1, Math.max(0, alpha || 1));

  return `rgba(${r}, ${g}, ${b}, ${validAlpha})`;
}

export function RGBAToHex(rgbaString: string) {
  const rgbaMatch = rgbaString.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
  if (!rgbaMatch) {
    throw new Error("Ongeldige RGBA-string: " + rgbaString);
  }

  // Haal de RGBA-componenten uit de overeenkomsten
  const r = parseInt(rgbaMatch[1], 10);
  const g = parseInt(rgbaMatch[2], 10);
  const b = parseInt(rgbaMatch[3], 10);

  // Zet de RGBA-componenten om naar een hexadecimale kleurwaarde
  const hexR = r.toString(16).padStart(2, '0');
  const hexG = g.toString(16).padStart(2, '0');
  const hexB = b.toString(16).padStart(2, '0');

  return `#${hexR}${hexG}${hexB}`;
}
